
export const GET_CALENDAR_APPOINTMENTS_STARTED = "GET_CALENDAR_APPOINTMENTS_STARTED"
export const GET_CALENDAR_APPOINTMENTS_SUCCESS = "GET_CALENDAR_APPOINTMENTS_SUCCESS"
export const GET_CALENDAR_APPOINTMENTS_FAILURE = "GET_CALENDAR_APPOINTMENTS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
